<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.giftCard.title.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naziv</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="giftCard.title"
                      />

                      <form-error
                        :model="$v.giftCard.title"
                        label="Naziv"
                        :dirty="$v.giftCard.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.giftCard.code.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Poklon kod</label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="d-flex">
                        <input
                          type="text"
                          class="form-control form-control-modern"
                          placeholder="Poklon kod"
                          v-model="giftCard.code"
                        />
                        <button
                          type="button"
                          class="btn btn-primary ms-1"
                          @click="generateCode()"
                        >
                          Generiraj
                        </button>
                      </div>
                      <form-error
                        :model="$v.giftCard.code"
                        label="Poklon kod"
                        :dirty="$v.giftCard.$dirty"
                      />
                    </div>
                  </div>

                  <div
                     class="form-group row align-items-center mb-3"
                     :class="{ 'has-danger': $v.giftCard.businessType.$anyError }"
                   >
                     <label
                       class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                       >B2B/B2C</label
                     >
                     <div class="col-lg-7 col-xl-6">
                       <treeselect
                       v-model="giftCard.businessType"
                       class="w-100 custom-vue-tree-select"
                       :options="b2bOrb2cOptions"
                       placeholder="B2B/B2C"
                       @select="handleChangeB2BB2C"
                       @deselect="handleChangeB2BB2C"
                     />

                      <form-error
                        :model="$v.giftCard.businessType"
                        label="B2B/B2C"
                        :dirty="$v.giftCard.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.giftCard.discount.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Vrijednost kôda</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Vrijednost kôda"
                        v-model.number="giftCard.discount"
                      />

                      <form-error
                        :model="$v.giftCard.discount"
                        label="Vrijednost kôda"
                        :dirty="$v.giftCard.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.giftCard.minimumTotalAmount.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Minimalni iznos narudžbe</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Minimalni iznos narudžbe"
                        v-model.number="giftCard.minimumTotalAmount"
                      />

                      <form-error
                        :model="$v.giftCard.minimumTotalAmount"
                        label="Minimalni iznos narudžbe"
                        :dirty="$v.giftCard.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.giftCard.limitationUsageNumber.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Limit upotrebe</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Limit upotrebe"
                        v-model.number="giftCard.limitationUsageNumber"
                      />

                      <form-error
                        :model="$v.giftCard.limitationUsageNumber"
                        label="Limit upotrebe"
                        :dirty="$v.giftCard.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.giftCard.startDate.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Vrijedi od</label>
                    <div class="col-lg-7 col-xl-6">
                      <date-picker
                        type="datetime"
                        placeholder="Vrijedi od"
                        v-model="giftCard.startDate"
                        input-class="form-control form-control-modern bg-body"
                        class="date-picker-width"
                        format="DD.MM.YYYY HH:mm"
                        :lang="options"
                      ></date-picker>

                      <form-error
                        :model="$v.giftCard.startDate"
                        label="Vrijedi od"
                        :dirty="$v.giftCard.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.giftCard.endDate.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Vrijedi do</label>
                    <div class="col-lg-7 col-xl-6">
                      <date-picker
                        type="datetime"
                        placeholder="Kraj"
                        v-model="giftCard.endDate"
                        input-class="form-control form-control-modern bg-body"
                        class="date-picker-width"
                        format="DD.MM.YYYY HH:mm"
                        :lang="options"
                      ></date-picker>

                      <form-error
                        :model="$v.giftCard.endDate"
                        label="Vrijedi do"
                        :dirty="$v.giftCard.$dirty"
                      />
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">

                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row pb-3">
                        <label
                          class="col-lg-5 col-xl-3 control-label text-lg-end mb-0 mt-2"
                          >Pretraga korisnika</label
                        >
                        <div class="col-lg-7 col-xl-6 pb-4 position-relative">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Pretraga"
                            v-model="searchField"
                            @input="onSearchHandle('getUsers')"
                            @blur="onBlurHandle"
                            :disabled="giftCard.businessType === null || giftCard.businessType === undefined"
                          />

                          <ul
                            class="article-list bg-body"
                            v-if="showSearchResults"
                          >
                            <li
                              v-for="item in users"
                              :key="item.id"
                              @click="addUser(item)"
                            >
                              <div>
                                {{ item.firstName }} {{ item.lastName }}
                              </div>
                             </li>
                          </ul>
                        </div>

                        <div
                          class="dataTables_wrapper dt-bootstrap5 no-footer"
                          v-if="
                            giftCard.users &&
                            giftCard.users.length > 0
                          "
                        >
                          <div class="table-responsive">
                            <table
                              class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                            >
                              <thead>
                                <tr role="row">
                                  <th class="sorting">Rbr</th>
                                  <th class="sorting">Ime i prezime</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  role="row"
                                  v-for="(
                                    item, index
                                  ) in giftCard.users"
                                  :key="item.userId"
                                  :class="{
                                    odd: index % 2 === 0,
                                    even: index % 2 !== 0,
                                  }"
                                >
                                  <td>
                                    <strong>{{ index + 1 }}</strong>
                                  </td>
                                  <td>
                                    <strong>{{ item.firstName }} {{item.lastName}}</strong>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      class="btn"
                                      @click="deleteUser(item)"
                                    >
                                      <i class="bx bx-trash text-4 me-2"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3" exact
            :to="{ name: 'GiftCards' }">
            {{ translations.cancel }}
          </router-link>
          <button type="submit"
            class="ubmit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { uuid } from 'uuidv4';
import { debounce } from 'lodash';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import bs from 'vuejs-datepicker/dist/locale/translations/bs';
import validations from "./validation-schema/add";
import FormError from "../shared/form-errors/FormError.vue";

import { translations } from '@/mixins';
import api from '@/services/api';

export default {
  name: 'AddPromoCode',
  mixins: [translations],
  components: {
    DatePicker,
    Treeselect,
    FormError,
  },
  data() {
    return {
      searchField: '',
      showSearchResults: false,
      options: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
    };
  },
  validations: {
    giftCard: validations
  },
  computed: {
    isFormValid() {
      return !this.$v.giftCard.$invalid;
    },
    bs() {
      return bs;
    },
    giftCard() {
      return this.$store.getters.getGiftCard;
    },
    users() {
      var data = this.$store.getters.getUsers;
      return data.filter((x) => !this.giftCard.users.map((a) => a.userId).includes(x.id));
    },
    b2bOrb2cOptions() {
      return [
        { id: 1, label: 'B2B' },
        { id: 2, label: 'B2C' },
      ];
    },
  },
  methods: {
    onSearchHandle: debounce(function (actionName) {
      this.showSearchResults = true;
      this.$store.dispatch(actionName, {
        sortBy: 'firstName',
        isSortAscending: true,
        b2b: this.giftCard.businessType == 1 ? true : null,
        b2c: this.giftCard.businessType == 2 ? true : null,
        page: 1,
        retrieveAll: true,
        quickSearch: this.searchField.trim(),
      });
    }, 300),
    onBlurHandle: debounce(function () {
    }, 300),
    generateCode() {
      const uuidV4 = uuid().split('-')[0];
      this.giftCard.code = `${uuidV4}-`;
    },
    addUser(user) {
      const { id, firstName, lastName } = user;

      const parsedUser = {
        userId: id,
        firstName,
        lastName
      };

      const foundUser = this.giftCard.users.find(
        (item) => item.userId === user.id
      );

      this.showSearchResults = false;
      this.searchField = '';

      if (foundUser) {
        this.$toast.error('Korisnik je već dodat.');
        return;
      }
      this.giftCard.users.push(parsedUser);
    },
    deleteUser(user) {
      const index = this.giftCard.users.findIndex(
        (item) => item.userId === user.userId
      );
      this.giftCard.users.splice(index, 1);
    },
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      let { giftCard } = this;

      if (giftCard.minimumTotalAmount === '') 
      {
        giftCard.minimumTotalAmount = null;
      }

      giftCard.userIds = giftCard.users.map(item => item.userId);

      api.updateGiftCard(giftCard)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'GiftCards' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    handleChangeB2BB2C(){
      this.showSearchResults = false;
      this.searchField = "";
      this.giftCard.users = [];
      this.giftCard.userIds = [];
    },
  },
  mounted() {
    this.$store.dispatch('getGiftCard', parseInt(this.$route.params.id, 10));
    console.log(this.giftCard);
  },
};
</script>

<style lang="scss" scoped>
.position-relative {
  position: relative;
}

.article-list {
  position: absolute;
  margin-top: 3px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  list-style: none;
  padding: 0;
  z-index: 1;
  left: 12px;
  right: 12px;
  top: 40px;
  overflow-y: auto;
  max-height: 200px;

  li {
    display: block;
    border-top: 1px solid #ced4da;
    padding: 0 10px;
    cursor: pointer;
    overflow: hidden;

    &:first-child {
      border-top: none;
    }
  }
}

.card-articles {
  margin-bottom: 100px;
}

.date-picker-width {
    width: 100%;
}

.custom-vue-tree-select .vue-treeselect__control {
  border: 1px solid #e7e7e7;
}
</style>